module.exports = __webpack_public_path__ + "static/media/01_themagician.13a386f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/01_themagician.png
// module id = 64
// module chunks = 0